import { Box, HStack, Stack, Text } from "@chakra-ui/react";
import * as React from "react";
import { Outlet, useLocation } from "react-router-dom";

import { useBreadcrumbs } from "../../../components/breadcrumbs";
import Link from "../../../components/link";
import Page from "../../../components/page";
import PageHeader from "../../../components/page-header";
import { useWorkspaceURL } from "../../../hooks";

// One entry per category; each is rendered by its own nested route
// (see frontend/routes/index.tsx) below this layout.
const CATEGORIES = [
  { path: "company-profile", label: "Company & Product" },
  { path: "ideal-customer-profile", label: "Ideal Customer Profile" },
  { path: "customer-profile-subsets", label: "ICP Subsets" },
  { path: "competitor-profiles", label: "Competitor Profiles" },
  { path: "messaging-pillars", label: "Messaging Pillars" },
  { path: "business-features", label: "Business Features" },
  { path: "content-library", label: "Content Library" },
  { path: "social-proofs", label: "Social Proofs" },
  { path: "brand-message", label: "Brand & Communication" },
];

export default function CompanyKnowledgeRoot() {
  const workspaceURL = useWorkspaceURL();
  const location = useLocation();
  useBreadcrumbs([{ label: "Settings" }, { label: "Company Knowledge" }]);

  return (
    <Page>
      <Stack flex="1" gap="6">
        <PageHeader
          title="Company Knowledge"
          subtitle="Tell the product about your company, customers, competitors, and brand so it can work for you."
        />
        <HStack align="stretch" gap="6">
          <Stack
            borderColor="border.soft"
            borderRightWidth="1"
            flexShrink="0"
            gap="0"
            minWidth={"220px" as any}
          >
            {CATEGORIES.map(({ path, label }) => {
              const to = workspaceURL(`settings/company-knowledge/${path}`);
              const isActive =
                location.pathname === to ||
                location.pathname.startsWith(`${to}/`);
              return (
                <Box
                  key={path}
                  background={isActive ? "bg.hover" : undefined}
                  borderRadius="l1"
                  fontWeight={isActive ? "medium" : "normal"}
                  paddingX="3"
                  paddingY="2"
                >
                  <Link
                    color={isActive ? "fg.ink" : "fg.muted"}
                    _hover={{
                      color: "fg.ink",
                      textDecoration: "none",
                    }}
                    to={to}
                  >
                    <Text fontSize="sm">{label}</Text>
                  </Link>
                </Box>
              );
            })}
          </Stack>
          <Box flex="1">
            <Outlet />
          </Box>
        </HStack>
      </Stack>
    </Page>
  );
}
